import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { ContatosService } from '../../../services/contatos.service';
import { ProfissionalService } from '../../../services/profissional.service';

@Component({
    selector: 'app-contatos-component',
    templateUrl: 'contatos-component.html',
    styleUrls: ['./contatos-component.scss']
})

export class ContatosComponent implements OnInit {

    emptyState = {
        imgUrl: '/assets/imgs/bg-contatos.svg',
        title: 'O paciente não possui registro de contatos de emergência',
        text: 'Essa área é dedicada à apresentação de contatos de emergência familiares ou conhecidos fornecidos pelo paciente.',
    };

    arrayObj: any[];
    listContatos: any[] = [];
    listContatosByOrder: any = [];

    constructor(
        private loadingCtrl: LoadingController,
        private profissionalService: ProfissionalService,
        private contatosService: ContatosService,
    ) {
    }

    async ngOnInit() {
        await this.loadData();
    }

    async loadData() {
        const loading = await this.loadingCtrl.create({
            cssClass: 'superapp-loader',
            spinner: 'crescent'
        });
        await loading.present();
        const prof = await this.profissionalService.recuperar();
        const contact = await this.contatosService.recuperar();

        let list = [];
        list = list.concat(prof);
        list = list.concat(contact);

        if (list.length > 0) {
            this.listContatos = list;
            await this.formataLista();
        }

        await loading.dismiss();
    }

    async formataLista() {
        this.listContatosByOrder = {
            'A': [], 'B': [], 'C': [], 'D': [], 'E': [], 'F': [], 'G': [], 'H': [], 'I': [], 'J': [], 'K': [], 'L': [], 'M': [], 'N': [],
            'O': [], 'P': [], 'Q': [], 'R': [], 'S': [], 'T': [], 'U': [], 'V': [], 'X': [], 'Y': [], 'Z': []
        };

        this.listContatos.forEach(contato => {
            let inicial = contato.nome ? contato.nome.substring(0, 1) : contato.nomeProfissionalSaude.substring(0, 1);
            this.listContatosByOrder[inicial.toUpperCase()].push(contato);
        })

        this.arrayObj = Object.keys(this.listContatosByOrder);
    }
}
